<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <h1><span>Parabéns, {{solicitacao.Nome.split(" ")[0]}}</span>VOCÊ FOI PRÉ-APROVADO!</h1>
      <p>Agora, por favor, forneça seu <strong>nome completo</strong> e seu <strong>CPF</strong>.</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="nomeCompleto">Nome completo</label>
            <input type="text" class="form-control form-control-lg" v-model="nomeCompleto"  @keyup="AlterarNome" placeholder="Nome Completo" required>
          </div>
          <div class="form-group text-left">
            <label for="Cpf" class="float-left">CPF</label>
            <input type="text" class="form-control form-control-lg" v-model="cpf" v-mask="'cpf'" placeholder="CPF" required>
          </div>
          <div class="form-group text-left">
            <label for="DataNascimento">Data de Nascimento</label>
            <input name="DataNascimento" type="text" class="form-control form-control-lg" v-model="dataNascimento" placeholder="__/__/____" v-mask="'date'" required>
          </div>
          <div class="text-center fixedOptions">
            <button v-focus class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import Masker from '@/utils/masker'

export default {
  data() {
    const solicitante = this.solicitacao.Solicitante
    return {
      nomeCompleto: solicitante ? solicitante.NomeCompleto : this.solicitacao.Nome,
      cpf: solicitante ? solicitante.Cpf : null,
      dataNascimento: (solicitante && solicitante.DataNascimento) ? new Date(solicitante.DataNascimento).toLocaleDateString('pt-BR') : null
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      if(this.nomeCompleto.indexOf(" ") <= -1) {
        this.$Notify.error('Digite seu nome completo!');
      } else {
        this.$emit('on-submit', {
          Solicitante: {
            NomeCompleto: this.nomeCompleto,
            Cpf: Masker.unmaskCpf(this.cpf),
            DataNascimento: new Date(this.dataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"))
          }
        })
      }

    }, AlterarNome(event) {

            var texto = event.target.value;

            var textoFinal = "";
            texto = texto.toLowerCase();

            if (texto.length > 0) {
                textoFinal = texto.substr(0, 1).toUpperCase()

                for (var i = 1; i < texto.length; i++) {
                    if (texto.substr(i - 1, 1) == " ") {
                        textoFinal += texto.substr(i, 1).toUpperCase();
                    } else {
                        textoFinal += texto.substr(i, 1);
                    }
                }
            }

          event.target.value =  textoFinal;
        }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/RepresentativeFullNameStep.vue